<template>
  <div
    class="select"
    :class="{
      'select--disabled': disabled,
      'select--start': started
    }"
    @click="handleClick"
    v-click-outside="close"
  >
    <span>{{ displayValue }}</span>

    <div class="options" v-show="open">
      <div class="options__inner">
        <div v-if="cancelable" class="option" @click="$emit('input', null)">
          {{ $t("common.none") }}
        </div>
        <div
          v-for="option in options"
          :key="option.value"
          class="option"
          @click="$emit('input', option[valueProperty])"
        >
          {{ option[titleProperty] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VSelect",
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cancelable: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    titleProperty: {
      type: String,
      default: () => "title"
    },
    valueProperty: {
      type: String,
      default: () => "value"
    }
  },

  data() {
    return {
      open: false,
      started: false
    };
  },

  computed: {
    displayValue() {
      if (this.value && this.options) {
        const compare = option => option[this.valueProperty] === this.value;
        return this.options.find(compare)[this.titleProperty];
      } else {
        // eslint-disable-next-line
        this.started = true;
        return this.placeholder;
      }
    }
  },

  methods: {
    handleClick() {
      if (this.open) {
        this.$emit("closed");
      }
      this.open = this.disabled ? false : !this.open;
    },
    close() {
      if (this.open) {
        this.$emit("closed");
      }
      this.open = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/variables";

.select {
  border: 1px solid $color-grey;
  border-radius: 3px;
  padding: 12px 16px;
  font-size: 13px;

  background-image: url("~@/assets/icons/arrow.svg");
  background-color: #fdfdfd;
  background-repeat: no-repeat;
  background-position: right 12px center;

  cursor: pointer;

  user-select: none;
  position: relative;

  &--disabled {
    color: $color-medium-grey;
    background-color: #f2f2f2;
    opacity: 0.5;
  }
}

.options {
  margin-top: 13px;
  position: absolute;
  background: #fdfdfd;
  width: calc(100% - 19px);
  z-index: 99;
  left: 0;
  border-radius: 0 0 3px 3px;
  border: 1px solid $color-grey;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);
  padding: 10px 8px;
  &__inner {
    overflow: auto;
    max-height: 225px;
  }
}
.select--start {
  span {
    opacity: 0.75;
  }
}

::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 4px;
  transition: all 0.2s;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.option {
  color: $color-black;
  padding: 11px 7px;
  font-size: 13px;
  letter-spacing: 0.4px;
  color: #464646;
  cursor: pointer;
}
</style>
